import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fundwalletpage',
  templateUrl: './fundwalletpage.component.html',
  styleUrls: ['./fundwalletpage.component.css']
})
export class FundwalletpageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
